const canais = {
  interno: 1,
  whatsapp: 2,
}

export { canais }
